<template>
  <div>
    <Search />
    <div style="height: 112px; width: 100%" />
    <div class="p-content firm-container">
      <div class="firm-title">商城简介</div>
      <div class="firm-item">
        浪潮终端优选（www.iitpm.com），是浪潮智能终端有限公司根据战略规划，打造的B2B供应链交易平台，整合内外部资源，围绕区域经销商等用户，沉淀商流、物流、信息流等有效数据要素，借助浪潮智能终端信用背书，引入战略合作金融机构对平台数据进行量化分析，推出金融等多元化体系赋能智能终端上下游企业，推动产业链整合升级。
      </div>
      <div class="firm-item">
        浪潮终端优选平台以产业交易的服务者、基础设施的提供者、信用体系的构建者为己任，为用户提供浪潮智能终端全产业链产品，一站式工厂生产+直采+运营的数智化服务。
      </div>
      <div class="firm-item">
        浪潮终端优选平台产品包括浪潮智能终端旗下的自研产品：超高清交互显示终端、智慧服务终端、智慧家庭终端、智慧医疗终端、虚拟现实终端；各类方案馆：智慧融媒馆、智能工业设计馆、智慧空间馆、智慧文旅馆等；生态类产品：音视频类、控制类、电源等辅材类产品。
      </div>
      <div class="firm-item">
        浪潮终端优选平台依托强大的技术能力、品牌能力、产业化能力、运营能力和销售能力，集展示、销售、服务于一体，整合资源，赋能上下游企业，面对新形势、新发展以更融合、更开放的姿态，不断提升服务品质和方案优化。
      </div>
    </div>
  </div>
</template>

<script>
import Search from '@/components/Search'
export default {
  name: 'FirmIntro',
  components: {
    Search
  },
  beforeRouteEnter(to, from, next) {
    window.scrollTo(0, 0)
    next()
  }
}
</script>

<style scoped>
.firm-container {
  border-bottom: 1px solid #ebebeb;
  padding-bottom: 50px;
}
.firm-title {
  font-size: 18px;
  color: black;
  font-weight: bold;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 10px;
}
.firm-item {
  font-size: 14px;
  color: #3f3f3f;
  margin-top: 10px;
  text-indent: 2em;
  line-height: 25px;
}
</style>
